const STORAGE_PREFIX = "columns";

const buildStorageKey = (entityKey, userId) => `${STORAGE_PREFIX}:${entityKey}:${userId}`;

export const getStoredColumns = (entityKey, userId) => {
  if (!entityKey || !userId) return null;
  try {
    const raw = localStorage.getItem(buildStorageKey(entityKey, userId));
    const parsed = raw ? JSON.parse(raw) : null;
    return Array.isArray(parsed) ? parsed : null;
  } catch (_e) {
    return null;
  }
};

export const setStoredColumns = (entityKey, userId, columns) => {
  if (!entityKey || !userId || !Array.isArray(columns)) return;
  try {
    localStorage.setItem(buildStorageKey(entityKey, userId), JSON.stringify(columns));
  } catch (_e) {
    // ignore (private browsing / storage quota)
  }
};
